module.exports = __webpack_public_path__ + "img/rolePer.553cf15e.svg";